import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Portal} from 'react-portal';
import mergeClassNames from 'classnames';

import {selectors} from '@neos-project/neos-ui-redux-store';

import {Icon, Button} from '@neos-project/react-ui-components';

import style from './style.module.css';

@connect(state => {
    const isDirty = selectors.UI.Inspector.isDirty(state);
    const shouldPromptToHandleUnappliedChanges = selectors.UI.Inspector.shouldPromptToHandleUnappliedChanges(state);
    const unappliedChangesOverlayIsVisible = isDirty && !shouldPromptToHandleUnappliedChanges;

    return {
        isFringeLeft: state?.ui?.leftSideBar?.isHidden,
        isFringeRight: state?.ui?.rightSideBar?.isHidden,
        isFullScreen: state?.ui?.fullScreen?.isFullScreen,
        unappliedChangesOverlayIsVisible
    };
})
export default class SecondaryInspector extends PureComponent {
    static propTypes = {
        isFringeLeft: PropTypes.bool.isRequired,
        isFringeRight: PropTypes.bool.isRequired,
        isFullScreen: PropTypes.bool.isRequired,
        unappliedChangesOverlayIsVisible: PropTypes.bool.isRequired,

        // Interaction related propTypes.
        onClose: PropTypes.func.isRequired,
        children: PropTypes.element.isRequired
    };

    render() {
        const {
            onClose,
            children,
            isFringeLeft,
            isFringeRight,
            isFullScreen,
            unappliedChangesOverlayIsVisible
        } = this.props;
        const finalClassName = mergeClassNames({
            [style.secondaryInspector]: true,
            [style['secondaryInspector--isFringeLeft']]: !isFullScreen && isFringeLeft,
            [style['secondaryInspector--isFringeRight']]: !isFullScreen && isFringeRight,
            [style['secondaryInspector--isElevated']]: unappliedChangesOverlayIsVisible
        });

        const appNode = document.getElementById('neos-application');

        return (
            <Portal node={appNode}>
                <div className={finalClassName}>
                    <Button
                        style="clean"
                        className={style.close}
                        onClick={onClose}
                        >
                        <Icon icon="times"/>
                    </Button>
                    {children}
                </div>
            </Portal>
        );
    }
}
